const BROWSER_IP_ENDPOINT = 'https://api.ipify.org?format=json';

let browserIpPromise;

export const fetchBrowserClientIp = async () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!browserIpPromise) {
    browserIpPromise = fetch(BROWSER_IP_ENDPOINT)
      .then(response => {
        if (!response.ok) {
          return null;
        }

        return response.json();
      })
      .then(data => (data && data.ip ? data.ip : null))
      .catch(() => null);
  }

  return browserIpPromise;
};